import { Species } from '../api/species';

export interface EggSpeciesDefaults {
  incubationDays: number;
  bandingNotificationDays: number;
}

type SpeciesLike = Partial<Pick<Species, 'hatchingPeriod' | 'incubationPeriod' | 'daysBeforeBanding'>> | null | undefined;

function resolveIncubationDays(species?: SpeciesLike): number {
  const incubation = species?.incubationPeriod;
  if (incubation != null && incubation > 0) return incubation;
  const hatching = species?.hatchingPeriod;
  if (hatching != null && hatching > 0) return hatching;
  return 18;
}

function resolveDaysBeforeBanding(species?: SpeciesLike): number {
  const days = species?.daysBeforeBanding;
  return days != null && days > 0 ? days : 14;
}

/** Defaults for new eggs from species breeding fields (male bird preferred). */
export function getEggDefaultsFromSpecies(species?: SpeciesLike): EggSpeciesDefaults {
  return {
    incubationDays: resolveIncubationDays(species),
    bandingNotificationDays: resolveDaysBeforeBanding(species),
  };
}

export function getEggDefaultsFromPair(pair?: {
  maleBirdEntity?: { species?: SpeciesLike };
  femaleBirdEntity?: { species?: SpeciesLike };
  male_bird?: { species?: SpeciesLike };
  female_bird?: { species?: SpeciesLike };
} | null): EggSpeciesDefaults {
  const species =
    pair?.maleBirdEntity?.species ??
    pair?.male_bird?.species ??
    pair?.femaleBirdEntity?.species ??
    pair?.female_bird?.species;
  return getEggDefaultsFromSpecies(species);
}

export function getEggDefaultsFromClutch(clutch?: {
  breeding_pair?: {
    male_bird?: { species?: SpeciesLike };
    female_bird?: { species?: SpeciesLike };
  };
} | null): EggSpeciesDefaults {
  const species =
    clutch?.breeding_pair?.male_bird?.species ??
    clutch?.breeding_pair?.female_bird?.species;
  return getEggDefaultsFromSpecies(species);
}
